/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { coerceNumberProperty } from '@angular/cdk/coercion';
import { Directive, Input, OnInit } from '@angular/core';
import {
  PAGE_ENVIRONMENT_PROVIDER,
  PageEnvironment,
  PageEnvironmentProvider,
} from './page-environment.interfaces';

const MIN_DESKTOP_SCREEN_WIDTH = 960;

export interface DesktopPageEnvironment extends PageEnvironment {
  minWidth?: number;
}

export const createDesktopPageEnvironment = (minWidth: number = MIN_DESKTOP_SCREEN_WIDTH): DesktopPageEnvironment =>
  ({ name: 'desktop', minWidth });

export const DEFAULT_DESKTOP_PAGE_ENVIRONMENT = createDesktopPageEnvironment();

export const desktopPageEnvironmentStyleFactory = (env: DesktopPageEnvironment) =>
  `html, body { min-width: ${env.minWidth}px; }`;

@Directive({
  standalone: false,
  selector: 'gh-desktop-env',
  providers: [{ provide: PAGE_ENVIRONMENT_PROVIDER, useExisting: DesktopPageEnvironmentDirective }],
})
export class DesktopPageEnvironmentDirective implements OnInit, PageEnvironmentProvider {
  environment: PageEnvironment;

  private _minWidth?: number;

  @Input()
  set minWidth(minWidth: any) {
    this._minWidth = coerceNumberProperty(minWidth);
  }

  get minWidth(): any {
    return this._minWidth;
  }

  ngOnInit(): void {
    this.environment = createDesktopPageEnvironment(this._minWidth);
  }
}
